import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { bool } from 'prop-types';
import classNames from 'classnames';
import { Price } from '@thd-olt-component-react/price';
import { ProductPodContext } from '../../ProductPodContext';
import './product-price.style.scss';

export const ProductPrice = (props) => {
  const {
    hideBulkPrice,
    hideLimitPerOrder,
    large
  } = props;

  const {
    hideRebates,
    hidePromotions,
    itemId,
    onSavingsCenterToggle,
    product: {
      availabilityType,
      info
    } = {},
    showExactPrice,
    showPreferredPricingBadge,
    showPreferredPricingBadgeToolTip,
    storeId,
    hidePriceBadge,
    hideSavingsText
  } = useContext(ProductPodContext);

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  if (availabilityType?.discontinued) return null;

  const priceContainerClasses = classNames('product-pod__price-wrapper', {
    'product-pod__price-wrapper--brio': info?.isBrioSku && !isMobile
  });

  return (
    <>
      <div className={priceContainerClasses} />
      <div className="product-pod__price-spacing-wrapper">
        <Price
          disableRangePricing={showExactPrice}
          hideBadge={hidePriceBadge}
          hideBulkPrice={hideBulkPrice}
          hideLimitPerOrder={hideLimitPerOrder}
          hidePromotions={hidePromotions}
          hideRebates={hideRebates}
          hideSavingsText={hideSavingsText}
          itemId={itemId}
          large={large}
          onSavingsCenterToggle={onSavingsCenterToggle}
          showPreferredPricingBadge={showPreferredPricingBadge}
          showPreferredPricingBadgeToolTip={showPreferredPricingBadgeToolTip}
          storeId={storeId}
        />
      </div>
    </>
  );
};

ProductPrice.displayName = 'ProductPrice';

ProductPrice.propTypes = {
  hideBulkPrice: bool,
  hideLimitPerOrder: bool,
  large: bool
};

ProductPrice.defaultProps = {
  hideBulkPrice: false,
  hideLimitPerOrder: false,
  large: true
};
